import React, { useEffect, useState } from "react";
import MultiSelect from "../modules/MultiSelect";
import exp from "../../Assets/svg/experience.svg";
import Button from "../modules/Button";
import { useNavigate } from "react-router-dom";
import { api } from "../../Services";
import { useSelector, useDispatch } from "react-redux";
import { addMentorInfo, addProfileId, resetClear } from "./redux/actions";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { doLogout } from "../LoginPage/redux/actions";

function SelectMentor() {
  const [skillList, setSkillList] = useState([]);
  const navigate = useNavigate();
  const mentors = useSelector((state) => state.connect.mentors);
  const myMentors = useSelector((state) => state.connect.myMentors);
  const [mentorList, setMentorList] = useState([]);

  const dispatch = useDispatch();
  const tokenData = useSelector((state) => state.tokens.tokens);
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const [skills, setSkills] = useState([
    "Resume Building",
    "Job and Internship applications",
    "Job Interviews",
    "Networking Skills",
    "Academics",
  ]);
  const getLogout = async () => {
    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log("logout api", users);

      dispatch(resetState());
      dispatch(resetIncome());
      dispatch(resetEdu());
      dispatch(resetRegister());
      dispatch(resetApp());
      dispatch(resetQueries());
      dispatch(resetStatus());
      dispatch(clearDisburse());
      dispatch(resetClear());
      dispatch(doLogout());
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };
  const getMentors = async () => {
    let data = {
      requiredHelpOn: skillList.length > 0 ? skillList.join(",") : null,
    };
    try {
      const mentorData = await api.getFilteredMentors(tokenData.token, data);

      if (mentorData.statusCode == 200) {
        dispatch(
          addMentorInfo({
            type: "mentors",
            value: mentorData.data ? [...mentorData.data] : [],
          })
        );
      }
    } catch (err) {
      console.log("err", err);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
  };
  const getMyMentors = async () => {
    try {
      const mentorData = await api.getMyMentors(
        tokenData.token,
        tokenData.applicationData.id
      );
      if (mentorData.statusCode == 200) {
        let mList = [];
        mentorData?.data.forEach((element) => {
          if (
            element?.requestStatus !== "Completed" ||
            element?.requestStatus !== "Accepted" ||
            element?.requestStatus !== "Decline"
          ) {
            mList = [...mList, element?.mentorId];
            setMentorList([...mList]);
          }
        });
        dispatch(
          addMentorInfo({
            type: "myMentors",
            value: mentorData?.data
              ? [...mentorData?.data?.sort((a, b) => a?.id - b?.id)?.reverse()]
              : [],
          })
        );
      } else if (
        mentorData.statusCode !== 200 &&
        mentorData.data.includes("Session expired")
      ) {
        logoutMsg();
      }
    } catch (err) {
      console.log("err", err);
      if (err?.statusCode !== 200 && err?.data?.includes("Session expired")) {
        logoutMsg();
      }
    }
  };
  const saveId = (id) => {
    dispatch(addProfileId(id));
    navigate("/application/connect/profile");
  };

  useEffect(() => {
    getMentors();
    getMyMentors();
  }, [skillList]);
  console.log("List", skillList);
  return (
    <div className="select-mentor-page">
      <div className="select-options">
        <div className="top-text">
          <span className="md-desc left">Find mentors based on</span>
          {/* <span className="md-desc right pointer">Clear all</span> */}
          <Button
            // disabled={true}
            onClickHandler={() => setSkillList([])}
            type={skillList.length > 0 ? "only-text" : "only-text-grey"}
            value={"Clear all"}
          />
        </div>
        <MultiSelect
          list={skillList}
          names={skills}
          type={"mentor"}
          getList={() => {}}
          onChange={(e) => setSkillList(e)}
          title={"What would you like help with"}
        />
        {/* <DropBtn
          title={"Location"}
          value={""}
          list={["Mumbai", "Bengalurr"]}
          onChange={(e) => {}}
        />
        <DropBtn
          title={"Department"}
          value={""}
          list={["IT"]}
          onChange={(e) => {}}
        /> */}
      </div>
      <div className="mentor-list">
        {mentors.map((item, index) => {
          return (
            <div className="mentor-card" key={index}>
              <div className="image">
                {/* <img src={avatar} alt="avatar" /> */}
                {item?.image && item?.imageExtension && (
                  <img
                    // className="image"
                    src={
                      "data:image/" +
                      item?.imageExtension +
                      ";base64," +
                      item?.image
                    }
                    alt="Preview"
                    // style={{ maxWidth: "100%", height: "100%" }}
                  />
                )}
              </div>
              <div className="mentor-right">
                <div className="md-title">{item?.fullName || item?.name}</div>
                <div className="set-title">
                  {item?.expertise}{" "}
                  {/* Digital Solutions Manager, Digital Experience */}
                </div>
                {/* <div className="set-title">
              <img src={star} alt="avatar" />
              4.2
            </div> */}
                {item?.experience && (
                  <div className="exp-line md-desc">
                    <div className="left">
                      <img src={exp} alt="avatar" />
                      {item?.experience.includes("years")
                        ? item?.experience
                        : `${item?.experience} years`}{" "}
                      of experience
                    </div>
                    {/* <div className="left">
                <img src={loc} alt="avatar" />
                Bengaluru, Karnataka
              </div> */}
                    {/* <div className="right"></div> */}
                  </div>
                )}
                <div className="options">
                  <div className="option-top md-desc">I can help you with</div>
                  <div className="skill-set">
                    {item?.provideHelp?.split(",")?.map((item, index) => {
                      return <div className="skill subTitle">{item}</div>;
                    })}
                  </div>
                </div>
                {mentorList.includes(item?.id) ? (
                  <Button
                    onClickHandler={() => {}}
                    type={"only-text-grey-2"}
                    value={"Request Sent"}
                  />
                ) : (
                  <Button
                    onClickHandler={() => saveId(item?.id)}
                    type={"contained"}
                    value={"View Details"}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SelectMentor;
